


































































































import { Component, Vue, Prop } from "vue-property-decorator";
import moment from "moment";
import { UseResultService } from "@/services/UseResult.service";
import Number from "@/shared/filters/Number";
import ComponentWithGroupShaten from "@/views/components/ComponentWithGroupShaten";
import FilterSelectBox from "@/shared/mixins/FilterSelectBox";

@Component({
  filters: {
    Number
  },
  mixins: [FilterSelectBox]
})
export default class UseResult extends ComponentWithGroupShaten {
  @Prop({ default: "" })
  title: string;
  service: UseResultService = new UseResultService();
  colNm: string[] = ["拠点", "予約件数", "連携済"];
  workProgressNm = [
    "開始前",
    "見積中",
    "検査中",
    "検査済",
    "点検中",
    "選択中",
    "待機中",
    "整備中",
    "整備保留",
    "部品待ち",
    "完検待ち",
    "割当中",
    "整備済",
    "完検中",
    "車検済",
    "中断"
  ];

  kyotenData: any = {};
  data: any = [];
  loading = false;

  created() {
    this.form = {
      groupCd: "",
      shatenCd: "",
      dateFrom: "",
      dateTo: ""
    };
    this.form.dateFrom = moment()
      .startOf("month")
      .format("YYYY-MM-DD");
    this.form.dateTo = moment()
      .endOf("month")
      .format("YYYY-MM-DD");

    this.getGroupDataList().then(res => {
      this.getShatenDataList();
      this.selectShaten1();
    });
  }

  selectShaten1() {
    this.getKyotenDataList().then(() => {
      this.getData();
    });
  }

  async getKyotenDataList() {
    const response = await this.accountService.getKyotens(
      this.form.groupCd,
      this.form.shatenCd
    );
    this.kyotenData = {};
    if (response) {
      response.forEach((e: any) => {
        this.kyotenData[e.kyotenCd] = e.kyotenNm;
      });
    }
    return response;
  }

  getData() {
    if (
      this.form.groupCd &&
      this.form.shatenCd &&
      this.form.dateFrom &&
      this.form.dateTo
    ) {
      if (this.form.dateFrom > this.form.dateTo) {
        const dTo = this.form.dateTo;
        this.form.dateTo = this.form.dateFrom;
        this.form.dateFrom = dTo;
      }
      this.loading = true;
      this.$set(this, "data", []);
      this.service.getUseResult(this.form).then((res: any) => {
        this.loading = false;
        if (res && res.recvCount && res.recvCount.length > 0) {
          const data = res.recvCount.map((e: any) => {
            let item = { ...e };
            item.kyotenNm = this.kyotenData[e.kyotenCd] || e.kyotenCd;
            item.progressCount = Array(16).fill(0);
            let cooperateCount = 0;
            if (res.cooperateCount) {
              const res1 = res.cooperateCount.find(
                (e1: any) => e1.kyotenCd == e.kyotenCd
              );
              if (res1) {
                cooperateCount = res1.recvCount;
              }
            }
            if (res.workProgressCount) {
              this.workProgressNm.map((p: any, i: number) => {
                const res1 = res.workProgressCount.find(
                  (e1: any) =>
                    e1.kyotenCd == e.kyotenCd && e1.workProgressState == i
                );
                if (res1) {
                  item.progressCount[i] = res1.recvCount;
                }
              });
            }
            return {
              ...item,
              cooperateCount
            };
          });

          const totalObj: any = {};
          totalObj.kyotenNm = "合計";
          totalObj.progressCount = Array(16).fill(0);
          totalObj.recvCount = data.reduce(
            (sum: any, cur: any) => sum + cur.recvCount,
            0
          );
          totalObj.cooperateCount = data.reduce(
            (sum: any, cur: any) => sum + cur.cooperateCount,
            0
          );

          this.workProgressNm.map((e: any, i: number) => {
            totalObj.progressCount[i] = data.reduce(
              (sum: any, cur: any) => sum + cur.progressCount[i],
              0
            );
          });

          data.push(totalObj);
          this.$set(this, "data", data);
        }
      });
    }
  }

  saveCSV() {
    if (this.form.groupCd && this.form.shatenCd) {
      const fName = `利用状況_${this.form.groupCd}_${
        this.form.shatenCd
      }_${this.form.dateFrom}_${this.form.dateTo}.csv`;

      const content = this.data.map(
        (e: any) =>
          `${e.kyotenNm},${e.recvCount},${
            e.cooperateCount
          },${e.progressCount.join(",")}`
      );
      let csvContent = [
        this.colNm.concat(this.workProgressNm).join(","),
        ...content
      ]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");
      const encoding = require("encoding-japanese");
      const strArray = encoding.stringToCode(csvContent);
      const sjisArray = encoding.convert(strArray, "SJIS", "AUTO");
      const uint8Array = new Uint8Array(sjisArray);
      const blob = new Blob([uint8Array], {
        type: "text/csv"
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", fName);
      link.click();
      window.URL.revokeObjectURL(url);
    }
  }

  rowClassName(rowobj: any) {
    const { rowIndex } = rowobj;
    if (rowIndex === this.data.length - 1) {
      return "row-total";
    }
    return "";
  }
}
